import React from 'react'
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import ReviewSlider from './components/ReviewSlider';
import FaqSection from './components/FaqSection';
import StillSection from './components/StillSection';
import ConditionModal from './components/ConditionModal';
import WhyUs from './components/WhyUs';

const Home = () => {
    return (
        <div className='flex flex-col w-full items-center justify-center'>
            <ConditionModal />
            <HeroSection />
            <FeatureSection />
            <WhyUs />
            <ReviewSlider />
            <FaqSection />
            <StillSection />
        </div>
    )
}

export default Home;